export const getLocalToken = () => localStorage.getItem('token');

export const saveLocalToken = (token: string) => localStorage.setItem('token', token);

export const removeLocalToken = () => localStorage.removeItem('token');

// https://stackoverflow.com/questions/1187518/how-to-get-the-difference-between-two-arrays-in-javascript
export const arrIntersection = (arrA, arrB) => arrA.filter((x) => arrB.includes(x));
export const arrDifference = (arrA, arrB) => arrA.filter((x) => !arrB.includes(x));
export const arrSymmetricDifference = (arrA, arrB) =>
  arrA.filter((x) => !arrB.includes(x)).concat(arrB.filter((x) => !arrA.includes(x)));

export const toTimestamp = (datetime) => {
  return (typeof datetime === 'string') ? new Date(`${datetime}T12:00:00-0300`).getTime() / 1000 : 0;
  // const myDate = (typeof datetime === 'number')
  //     ? new Date(datetime)
  //     : datetime;
  //
  // if (!myDate || (typeof myDate.getTime !== 'function')) {
  //   return 0;
  // }
  //
  // const getUTC = myDate.getTime();
  // const offset = myDate.getTimezoneOffset() * 60000; // It's in minutes so convert to ms
  // return getUTC - offset; // UTC - OFFSET
};

export const fromTimestamp = (datetime) => {
  if (!datetime) {
    return '-----';
  }
  if (typeof datetime === 'number') {
    datetime = datetime * 1000;
  }
  return new Date(datetime).toLocaleDateString('pt-BR');
  // const myDate = (typeof datetime === 'number')
  //     ? new Date(datetime*1000)
  //     : datetime;
  //
  // if (!myDate || (typeof myDate.getTime !== 'function')) {
  //   return 0;
  // }
  //
  // const getUTC = myDate.getTime();
  // const offset = myDate.getTimezoneOffset() * 60000; // It's in minutes so convert to ms
  // return getUTC + offset; // UTC + OFFSET
};


export const acceptableFiles = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'];

export const rules = {
  required: [
    // @ts-ignore
    (v) => !!v || window.getApp.lang('required'),
  ],
  email: [
    // @ts-ignore
    (v) => /.+@.+/.test(v) || window.getApp.lang('infos.email_must_be_valid'),
  ],
  sameAs: (v2) => [
    // @ts-ignore
    (v) => v === v2 || window.getApp.lang('infos.password_does_not_math'),
  ],
  lessThan: (v2) => [
    // @ts-ignore
    (v) => v <= v2 || `${window.getApp.lang('infos.less_than')} ${v2}`,
  ],
  greatThan: (v2) => [
    // @ts-ignore
    (v) => v >= v2 || `${window.getApp.lang('infos.great_than')} ${v2}`,
  ],
  without_whitespaces: [
    // @ts-ignore
    (v) => !!v || window.getApp.lang('required'),
    // @ts-ignore
    (v) => /^\w+$/.test(v) || window.getApp.lang('infos.without_whitespaces'),
  ],
  minSizeFile: (v2) => [
    (v) => !v || v.size > v2 * 1024 || `Este campo deve ser maior do que ${v2}Kb`,
  ],
  maxSizeFile: (v2) => [
    (v) => !v || v2 !== 0 || v.size < v2 * 1024 || `Este campo deve ser menor do que ${v2}Kb`,
  ],
  onlyPDF: [
    (v) => !v || v?.type === 'application/pdf' || `Só são aceitos arquivos no formato PDF`,
  ],
  acceptableFiles: [
    (v) => !v || (!!acceptableFiles.filter((e) => e === v?.type)) || `Só são aceitos arquivos no formato PDF, JPEG ou PNG`,
  ],
  isValidCPF: [
    (v) => CPFValidate(v) || `CPF Inválido.`
  ],
  isValidCNPJ: [
    (v) => CNPJValidate(v) || `CNPJ Inválido.`
  ]
};

export const getFormValuesHeaders = (formSettings) => {
  if (!formSettings) {
    return [];
  }
  let formValuesData = Object.values(formSettings).map((e: any) => {
    return {uniqueId: e?.uniqueId, name: e?.name, label: e?.label, type: e?.type};
  });

  formValuesData.unshift({uniqueId: 'id', name: 'id', label: 'ID do Formulário', type: 'number'});
  return formValuesData;
};

const CPFValidate = (cpf: string): boolean => {
  if (!cpf) return true;

  cpf = cpf.replace(/[^\d]+/g, ''); // Remove caracteres não numéricos

  if (cpf.length !== 11 || /^(.)\1+$/.test(cpf)) {
    return false; // CPF deve ter 11 dígitos e não pode ter todos os dígitos iguais
  }

  // Verifica o primeiro dígito verificador
  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let resto = 11 - (soma % 11);
  let digitoVerificador = resto === 10 || resto === 11 ? 0 : resto;
  if (digitoVerificador !== parseInt(cpf.charAt(9))) {
    return false; // Primeiro dígito verificador inválido
  }

  // Verifica o segundo dígito verificador
  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf.charAt(i)) * (11 - i);
  }
  resto = 11 - (soma % 11);
  digitoVerificador = resto === 10 || resto === 11 ? 0 : resto;
  if (digitoVerificador !== parseInt(cpf.charAt(10))) {
    return false; // Segundo dígito verificador inválido
  }

  return true; // CPF válido
}

const CNPJValidate = (cnpj: string): boolean => {
  if (!cnpj) return true;
  cnpj = cnpj.replace(/[^\d]+/g, ''); // Remove caracteres não numéricos

  if (cnpj.length !== 14) {
    return false; // CNPJ deve ter 14 dígitos
  }

  // Verifica o primeiro dígito verificador
  let soma = 0;
  let peso = 2;
  for (let i = 11; i >= 0; i--) {
    soma += parseInt(cnpj.charAt(i)) * peso;
    peso = peso === 9 ? 2 : peso + 1;
  }
  let digitoVerificador = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (digitoVerificador !== parseInt(cnpj.charAt(12))) {
    return false; // Primeiro dígito verificador inválido
  }

  // Verifica o segundo dígito verificador
  soma = 0;
  peso = 2;
  for (let i = 12; i >= 0; i--) {
    soma += parseInt(cnpj.charAt(i)) * peso;
    peso = peso === 9 ? 2 : peso + 1;
  }
  digitoVerificador = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (digitoVerificador !== parseInt(cnpj.charAt(13))) {
    return false; // Segundo dígito verificador inválido
  }

  return true; // CNPJ válido
}

const SI_SYMBOL = ['', 'k', 'M', 'G', 'T', 'P', 'E'];

export const abbreviateNumber = (val) => {
  const tier = Math.log10(Math.abs(val)) / 3 || 0;
  if (tier === 0) {
    return val;
  }

  const suffix = SI_SYMBOL[tier];
  const scale = Math.pow(10, tier * 3);

  const scaled = val / scale;

  return scaled.toFixed(1) + suffix;
};

export const stringToNumber = (v: string | undefined): string => {
  if (!v) return '';
  return v.replace(/[^\d]+/g, ''); // Remove caracteres não numéricos
}

class LRU {
  private readonly max: number;
  private cache: Map<any, any>;

  constructor(max = 5) {
    this.max = max;
    this.cache = new Map();
  }

  private get(key) {
    const item = this.cache.get(key);
    if (item) {
      // refresh key
      this.cache.delete(key);
      this.cache.set(key, item);
    }
    return item;
  }

  private set(key, val) {
    // refresh key
    if (this.cache.has(key)) {
      this.cache.delete(key);
    } else if (this.cache.size === this.max) {
      this.cache.delete(this.first());
    }
    this.cache.set(key, val);
  }

  private first() {
    return this.cache.keys().next().value;
  }
}
